module.exports = __webpack_public_path__ + "img/6.3ea31257.png";